import "./styles.css";
import { useContext } from "react";
import {
  Box,
  IconButton,
  Tooltip,
  Container,
  Grid,
} from "@mui/material";
import MenuTwoToneIcon from "@mui/icons-material/MenuTwoTone";
import CloseTwoToneIcon from "@mui/icons-material/CloseTwoTone";
import { SidebarContext } from "../../../contexts/SidebarContext";
import ZsBreadcrumbs from "../../../shared/components/breadcrumbs";
import HoverDropdown from "../../../shared/components/hoverDropdown";

function Header() {
  // const name = getLocalStorageData("name");
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);

  return (
    <Container>
      <Grid container className="subContainer" sx={{ p: 0.3 }}>
        <Box
          component="span"
          sx={{
            display: { lg: "none", xs: "inline-block" },
            margin: 0.3,
          }}
        >
          <Tooltip arrow title="Toggle Menu">
            <IconButton color="primary" onClick={toggleSidebar}>
              {!sidebarToggle ? (
                <MenuTwoToneIcon fontSize="small" />
              ) : (
                <CloseTwoToneIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
        <Grid item xs={10} sx={{ pt: 1 }}>
          <ZsBreadcrumbs />
        </Grid>

        <Grid item xs={2} className="userContainer">
          <HoverDropdown />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Header;